<template>
    <div class="col-md-12">
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
            {{customField.customFieldName}}
            </label>
            <input
            type="text"
            class="form-control shadow-none rounded-0 text-black" v-model="customField.customFieldValue"
            />
        </div>
        </div>
</template>
<script>
export default {
  name: "custom-field",
  props: {
    customField: {
      type: Object
    }
  }
};
</script>